import React from "react";
import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
  Icon,
} from "@chakra-ui/react";
import { WarningIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";

const CancelPage = () => {
  const navigate = useNavigate();

  return (
    <Box minH="80vh" bg="#F2EEE8" display="flex" alignItems="center" justifyContent="center">
      <VStack spacing={6} textAlign="center" maxW="md" bg="white" p={10} rounded="xl" shadow="md">
        <Icon as={WarningIcon} w={10} h={10} color="red.500" />
        <Heading size="lg">Payment Cancelled</Heading>
        <Text>You cancelled the payment. You can try again anytime.</Text>
        <Button onClick={() => navigate("/shopping-bag")} colorScheme="red" size="lg" rounded="md">
          Try Again
        </Button>
        <Button onClick={() => navigate("/discover-all")} variant="outline" size="md">
          Continue Shopping
        </Button>
      </VStack>
    </Box>
  );
};

export default CancelPage;
